import * as Yup from 'yup'

export default Yup.object().shape({
    email: Yup.string().email('Digite um e-mail válido!').required('E-mail é obrigatório!'),
    password: Yup.string().required('Senha é obrigatório!')
})